import { apiErrorCodes } from '../../utils/apiHelper'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getErrorMessage = (action) => {
  const errorCode = action.payload.ErrorCode
  if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
    return action.payload.UserFriendlyErrorCode ?
        getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
      : ''
  }
  switch (errorCode) {
    case apiErrorCodes.FORBIDDEN:
      return getUserFriendlyErrorMessage(errorCodes.CANNOT_MANUALLY_OVERRIDE, null, 'ID verification')
    case apiErrorCodes.ID_VERIFICATION_NOT_FOUND:
      return getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'ID verification')
    default:
      return getUserFriendlyErrorMessage(errorCodes.DEFAULT)
  }
}
